'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Empty = require('./Empty');

var _Empty2 = _interopRequireDefault(_Empty);

var _Full = require('./Full');

var _Full2 = _interopRequireDefault(_Full);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Empty: _Empty2.default, Full: _Full2.default };


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Dots/index.js
// module id = 202
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15